import { render, staticRenderFns } from "./AddManualDomainModal.vue?vue&type=template&id=30d116b8"
import script from "./AddManualDomainModal.vue?vue&type=script&lang=js"
export * from "./AddManualDomainModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports